import React from "react";

const PressComponent = () => {
  return (
    <div className="press-container">
      <p>AS SEEN ON: </p>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.thehindu.com/entertainment/art/bangalore-creative-circus-hosts-interactive-new-media-first-exhibition/article67938389.ece"
      >
        <img src="https://i.ibb.co/0GJpxCH/hindu.png" alt="Description" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.deccanherald.com/india/karnataka/bengaluru/b-luru-themed-immersive-exhibition-on-till-april-7-2957056"
      >
        <img src="https://i.ibb.co/tmtk1j1/dh.png" alt="Description" />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.newindianexpress.com/cities/bengaluru/2024/Mar/12/a-tech-art-odyssey"
      >
        <img src="https://i.ibb.co/27fm8mf/IE.png" alt="Description" />
      </a>
      <style jsx>{`
        .press-container {
          display: flex;
          flex-direction: row;
          margin: 1em 0em;
          background: white;
          align-items: center;
          width: 100%;
        }

        @media (max-width: 768px) {
          .press-container {
            flex-direction: column;
            height: auto;
            padding: 2em 0em;
          }
        }

        .press-container p {
          font: 500 22px Clash Display, -apple-system, Roboto, Helvetica,
            sans-serif;
          text-align: center;
          margin: auto;
          font-size: 1.5em;
          flex: 1;
        }
        .press-container a {
          flex: 1;
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

export default PressComponent;
